import { useEffect, useState } from 'react';

/**
 * 🔒 The pause before a typed search or a typed redraw runs (decision 3840): a quarter second after the last
 * key, for the dropdowns, the global search, the tax preview, the print preview, the API log search and the
 * Mail tag picker alike. The phone's search box keeps its own longer pause (piece 35).
 */
export const SEARCH_PAUSE_MS = 250;

/** The value as it stood `ms` after it last changed, so a field read on every key asks once when typing stops. */
export function useDebounced<T>(value: T, ms: number = SEARCH_PAUSE_MS): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return settled;
}
